"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledIbanInput = void 0;
var _ykbStyledComponents = _interopRequireDefault(require("../ykb-styled-components"));
var _TextInput = require("../TextInput");
var StyledIbanInput = exports.StyledIbanInput = (0, _ykbStyledComponents.default)(_TextInput.TextInput).withConfig({
  componentId: "ykb-ui__sc-1ib4jpv-0"
})(["min-width:260px;"]);